import ResourceSvc from '@/services/resource.svc.js';
import TextAnswer from '@/components/shared/answer-types/text/text.vue';
import CheckBoxAnswer from '@/components/shared/answer-types/checkbox/checkbox.vue';
import { YES_NO_OPTIONS, DEFAULTS } from '@/components/user/dashboard/pages/clubs/register-club/constants/club-registration-constants.js';

const resourceService = new ResourceSvc();

export default {
    name: 'AdminDocumentsSection',

    components: {
        'text-answer': TextAnswer,
        'checkbox-answer': CheckBoxAnswer
    },

    props: {
        club: {
            type: Object,
            required: true
        },
        documents: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            defaults: DEFAULTS,
            yesNoOptions: YES_NO_OPTIONS,
            downloadingTerms: false,
            downloadingSafeguard: false,
            downloadingConstitution: false
        };
    },

    computed: {
        localClub: {
            get() { return this.club; },
            set(value) { this.$emit('update:club', value); }
        }
    },

    methods: {
        setAcceptTerms(value) {
            const club = this.localClub;
            club.acceptTerms = value;
            this.$emit('update:club', club);
        },

        async downloadFile(fileId, loadingProp) {
            this[loadingProp] = true;
            try {
                const res = await resourceService.getAdminFile(fileId);
                const data = res.body;
                if (data && data.bytes && data.name) {
                    if (typeof download === 'function') {
                        download('data:application/pdf;base64,' + data.bytes, data.name, 'application/pdf');
                    } else {
                        this.$showError('Download library is not available');
                    }
                } else {
                    this.$showError('File not found');
                }
            } catch (e) {
                this.$showError('Error downloading file');
            } finally {
                this[loadingProp] = false;
            }
        },

        downloadTerms() {
            if (!this.documents.termsAndConditionsFileId) return;
            this.downloadFile(this.documents.termsAndConditionsFileId, 'downloadingTerms');
        },

        downloadSafeguard() {
            if (!this.documents.safeguardingStatementFileId) return;
            this.downloadFile(this.documents.safeguardingStatementFileId, 'downloadingSafeguard');
        },

        downloadConstitution() {
            if (!this.documents.constitutionFileId) return;
            this.downloadFile(this.documents.constitutionFileId, 'downloadingConstitution');
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/club/club-detail/sections/admin-documents-section/admin-documents-section.js